import React from 'react';
import styled, { keyframes } from 'styled-components';

const rotation = keyframes`
    from { transform: rotate(0) }
    to { transform: rotate(360deg) }
`;

const View = styled.div`
    width: 75px;
    height: 75px;
    border-radius: 50%;
    position: relative;
    background-color: #4a4a4a;
    animation ${rotation} 1s linear both infinite;

    &::before,
    &::after {
        content: '';
        position: absolute;
    }

    &::before {
        width: calc(100% - 16px);
        height: calc(100% - 16px);
        border-radius: 50%;
        top: 8px;
        left: 8px;
        background-color: #fff;
    }

    &::after {
        width: 30px;
        height: 20px;
        margin-left: -15px;
        top: 0;
        left: 50%;
        background-color: #fff;
    }
`;

const Loader = props => {
    return <View className={props.className} />;
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/shared/Loader.js